import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import BackButtonComponent from "../../components/BackButtonComponent/BackButtonComponent";
import {
  ContainerIframe,
  ContainerReports,
  GeneralStyle,
  HR,
} from "./DetailSpaceContainer.styled";

const DetailSpaceContainer = () => {
  const location = useLocation();
  const history = useHistory();

  const iframe = `<iframe name="embed-feed" title="Yammer" src="${location.state.url}" style="border: 0px; overflow: hidden; width: 100%; height: 100%; min-height: 610px;"></iframe>`;

  let goToBackPage = () => {
    history.push({ pathname: "/MySpaces" });
  };

  return (
    <GeneralStyle>
      <BackButtonComponent
        backtitle={"My Spaces"}
        locationtitle={"Space"}
        goToBackPage={goToBackPage}
      />
      <HR />
      <ContainerReports>
        <ContainerIframe
          contentEditable="true"
          dangerouslySetInnerHTML={{ __html: iframe }}
        ></ContainerIframe>
      </ContainerReports>
    </GeneralStyle>
  );
};

export default DetailSpaceContainer;
